import { useEffect } from 'react';
import type {
    IUserResponse,
    ICompanyResponse,
    IConfiguration
} from '~/types/server.types';
import { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import useLoadClientPortal from '~/components/ClientExperience/hooks/useLoadClientPortal';

interface Props {
    store: CXRootStore;
    config: IConfiguration;
    user: IUserResponse;
    company: ICompanyResponse;
    mobilePreviewMode?: any;
    isOnboardingPreview?: boolean;
}

export function loadStoreCredentials({
    store,
    user,
    config,
    company,
    mobilePreviewMode = null,
    isOnboardingPreview = false
}: Props) {
    const { userStore, companyStore, sessionStore, mobileStore, configStore } =
        store;

    configStore.setConfig(config);

    if (user) {
        userStore.update(user);
        sessionStore.setCurrUserId(user._id);
    }
    if (company) {
        companyStore.update(company);
        sessionStore.setCurrCompanyId(company._id);
    }
    mobileStore.setMobilePreviewMode(mobilePreviewMode);
    mobileStore.setIsOnboardingPreview(isOnboardingPreview);
}

export function useCXStoreCredentials({
    store,
    config,
    user,
    company,
    mobilePreviewMode = null,
    isOnboardingPreview = false
}: Props) {
    useLoadClientPortal({ isFromAngular: true });

    useEffect(() => {
        loadStoreCredentials({
            store,
            user,
            company,
            config,
            mobilePreviewMode,
            isOnboardingPreview
        });
    }, [company, config, isOnboardingPreview, mobilePreviewMode, store, user]);
}
